import React from 'react'
import Skeleton from 'react-loading-skeleton'

import styles from './styles.module.css'

const HeaderSkeleton = () => {
  return <Skeleton width={'100%'} height={74} className={styles.skeleton} />
}

export default HeaderSkeleton
